import { QuoteApprovalAPI, PricingPortalAPI } from "../apis/api-index";
import { AuthAPI } from "../apis/auth-api";
import { APIVersion } from "../apis/api-config";
import uuid from "react-uuid";

export const handleApproveRejectAction = async (email, businessCode, countryCode, action, quoteApprovalResponse, actionNotes) => {
  try {
    let approvalstatus = "";
    let res = null;
    if (action === "approve") {
      approvalstatus = "APPROVED";
    } else if (action === "reject") {
      approvalstatus = "REJECTED";
    }
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      quoteApproval: [
        {
          ...quoteApprovalResponse,
          quoteApprovalId: uuid(),
          status: approvalstatus,
          notes: actionNotes ? actionNotes : quoteApprovalResponse.notes,
        },
      ],
    };

    res = await QuoteApprovalAPI.updateQuoteApproval(postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleCreateDeviceAction = async (businessCode, countryCode, deviceDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      device: [
        {
          ...deviceDetails,
          Deleted: false,
          Frequencies: "1",
          CountryCode: countryCode,
          BusinessCode: businessCode,
          SalesPersonEmailId: email,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createDevice", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleDeletePezodeAction = async (businessCode, countryCode, pezodeDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;

    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      pezodein: [
        {
          PezodeId: pezodeDetails.id,
          Deleted: true,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createPezode", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleCreatePezodeAction = async (businessCode, countryCode, pezodeRecord) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      pezodein: [
        {
          ...pezodeRecord,
          Deleted: false,
          ImpactPercentage: 99999,
          Shock: false,
          CountryCode: countryCode,
          BusinessCode: businessCode,
          SalesPersonEmailId: email,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createPezode", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleCreateDeviceTypeAction = async (businessCode, countryCode, deviceTypeDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      devicetype: [
        {
          ...deviceTypeDetails,
          Deleted: false,
          CountryCode: countryCode,
          BusinessCode: businessCode,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createDeviceType", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleDeletePezodeRangeAction = async (businessCode, countryCode, pezodeRangeDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      pezoderange: [
        {
          PezodeRangeId: pezodeRangeDetails.PezodeRangeId,
          Deleted: true,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createPezodeRange", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleDeleteConsumableProductAction = async (businessCode, countryCode, consumableProductDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      consumableproduct: [
        {
          ConsumableProductId: consumableProductDetails.id,
          Deleted: true,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createConsumableProduct", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleCreateConsumableProductAction = async (businessCode, countryCode, consumableProductDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      consumableproduct: [
        {
          ...consumableProductDetails,
          Deleted: false,
          CountryCode: countryCode,
          BusinessCode: businessCode,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createConsumableProduct", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleDeletePezodeProductAction = async (businessCode, countryCode, pezodeProductDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      consumableproductmap: [
        {
          PezodeProductMapId: pezodeProductDetails.pezodeProductMapId,
          Deleted: true,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createPezodeProductMap", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handleDeleteReplacementProductAction = async (businessCode, countryCode, replacementProductDetails) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    let postRequest = {
      countryCode: countryCode,
      businessCode: businessCode,
      email: email,
      version: APIVersion,
      replacementProduct: [
        {
          ReplaceProductId: replacementProductDetails.ReplaceProductId,
          Deleted: true,
        },
      ],
    };

    res = await PricingPortalAPI.updateList("createReplacementProduct", postRequest);

    return res;
  } catch (err) {
    alert(err);
  }
};

export const handlePostAction = async (postRequest, entity) => {
  try {
    let res = null;
    let _curUser = await AuthAPI.validateCurrentUser();
    let email = _curUser.email;
    postRequest.email = email;
    postRequest.version = APIVersion;
    switch (entity) {
      case "branchcostconfig":
        res = await PricingPortalAPI.updateList("createBranchCostConfig", postRequest);
        break;
      case "grossBranch":
        res = await PricingPortalAPI.updateList("createGrossBranch", postRequest);
        break;
      case "marketsector":
        res = await PricingPortalAPI.updateList("createMarketSector", postRequest);
        break;
      case "servicetype":
        res = await PricingPortalAPI.updateList("createServiceType", postRequest);
        break;
      case "device":
        res = await PricingPortalAPI.updateList("createDevice", postRequest);
        break;
      case "pezode":
        res = await PricingPortalAPI.updateList("createPezode", postRequest);
        break;
      case "zone":
        res = await PricingPortalAPI.updateList("createZone", postRequest);
        break;
      case "consumableproduct":
        res = await PricingPortalAPI.updateList("createConsumableProduct", postRequest);
        break;
      case "devicetype":
        res = await PricingPortalAPI.updateList("createDeviceType", postRequest);
        break;
      case "approvalcoveringmanagerconfig":
        res = await PricingPortalAPI.updateList("createApprovalCoveringManagerConfig", postRequest);
        break;
      case "userrole":
        res = await PricingPortalAPI.updateList("createUserRole", postRequest);
        break;
      case "authsignconfig":
        res = await PricingPortalAPI.updateList("createAuthSignConfig", postRequest);
        break;
      case "GrossMarginLevel":
        res = await PricingPortalAPI.updateList("createGrossBranchLevel", postRequest);
        break;
      case "itineraryTimes":
        res = await PricingPortalAPI.updateList("createItineraryTimes", postRequest);
        break;
      case "auditinfo":
        res = await PricingPortalAPI.updateList("createAuditInfo", postRequest);
        break;
      case "pricingsettings":
        res = await PricingPortalAPI.updateList("createPricingSettings", postRequest);
        break;
      case "sendEmail":
        res = await PricingPortalAPI.updateList("createEmail", postRequest);
        break;
      default:
        break;
    }
    return res;
  } catch (err) {
    alert(err);
  }
};
